var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCourseListItemBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -5 33 54",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.002 44.041c0 1.203.473 2.356 1.316 3.206a4.476 4.476 0 003.178 1.328h27.043L32.176 0 0 .003l.002 44.038z",
    fill: "#08275c",
    fillRule: "nonzero"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj48c3ZnIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgLTUgMzMgNTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoyOyI+PHBhdGggZD0iTTAuMDAyLDQ0LjA0MWMtMCwxLjIwMyAwLjQ3MywyLjM1NiAxLjMxNiwzLjIwNmMwLjg0MywwLjg1IDEuOTg2LDEuMzI4IDMuMTc4LDEuMzI4bDI3LjA0MywwbDAuNjM3LC00OC41NzVsLTMyLjE3NiwwLjAwM2MwLDAgMC4wMDIsNDMuOTE0IDAuMDAyLDQ0LjAzOFoiIHN0eWxlPSJmaWxsOiMwODI3NWM7ZmlsbC1ydWxlOm5vbnplcm87Ii8+PC9zdmc+Cg==";
export { SvgCourseListItemBackground as ReactComponent };